import { PLATFORM_BATCH_PAGE } from '@constants/segment';
import WebNotifyMeOnPriceCard from '@cont/BatchGroup/NotifyMe/WebNotifyMeOnPriceCard';
import { getIsEnrollmentClosed } from '../utils';
import PlatformBatchHeader from '../PlatFormBatchHeader';

// when batch enrollment is closed for batch then show  notify otherwise show detail card(with price and join button)
const UnEnrolledBatchState = ({ batchDetails, entitySubType }) => {
  const { enrollmentEndDate } = batchDetails;
  const isEnrollmentClose = getIsEnrollmentClosed(enrollmentEndDate);
  if (isEnrollmentClose) {
    return <WebNotifyMeOnPriceCard />;
  }
  return (
    <PlatformBatchHeader
      isStickyCard
      batchGroupUID={batchDetails.uid}
      batchDetails={batchDetails}
      lastPrimarySourceSection={`${PLATFORM_BATCH_PAGE} - Batch Price Card`}
      entitySubType={entitySubType}
    />
  );
};
export default UnEnrolledBatchState;
